import { useNavigate } from 'react-router-dom'

export const SCAN_LOCATION_URL =
  '/assembly/detail/:transferId/:docNum/products/scan-location/:container'

export const useGoToScanLocation = () => {
  const navigate = useNavigate()

  return {
    go: (transferId: string, docNum: string, container: string) => {
      navigate(
        SCAN_LOCATION_URL.replace(':transferId', transferId)
          .replace(':docNum', docNum)
          .replace(':container', container)
      )
    }
  }
}
